import React, { useEffect, useRef, useState } from "react";
import {
  FormColumn,
  Img,
  ImgWrapper,
  FormWrapper,
  FormInput,
  FormSection,
  FormRow,
  FormTitle,
  FormLabel,
  FormInputRow,
  FormMessage,
  FormTextArea,
  FormSubTitle,
  AvatarWrapper,
  AvatarImage,
  AvatarSection,
  AvatarText,
} from "./FormStyles";
import styled from "styled-components";

import { Container, Button, Row, TextWrapper } from "../../globalStyles";
import { white } from "../../Colors";
import validateForm from "./validateForm";
import { LocationData } from "../../data/footerData";
import { Helmet } from "react-helmet";
import Avatar from "./AvatarImage";
import toast, { Toaster } from "react-hot-toast"; // Import Toaster from react-hot-toast
import itemNail from "../NailsMenu/dataNails";
import itemBeauty from "../BeautyMenu/dataBeauty";
import MultiSelectModal from "./MultiSelectModal";
import DateModal from "./DateModal";
import emailjs from "@emailjs/browser";
import TimeModal from "./TimeModal";
import { motion, AnimatePresence } from "framer-motion";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import SelectProfessional from "./SelectProfessional";
import TimeSlotSelector from "./Timeslotselector";
import { useDispatch, useSelector } from "react-redux";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import sericesApi from "../../api/service/service.api";
import Loading from "../../Util/Loading";
import staffApi from "../../api/staff/staff.api";
import bookingApi from "../../api/booking/BookingApi";
import ProcessingBar from "../../Util/Processingbar";
import SummaryCard from "./SummaryCard";
import { useNavigate } from "react-router-dom";

const FormBooking = (props) => {
  const { user } = useSelector((state) => state.user || {});

  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const locationTag = props.path.tag;
  const store = LocationData.find((location) =>
    location.fresha.includes(locationTag)
  );

  const fullstore = LocationData.filter((location) =>
    location.fresha.includes(locationTag)
  );

  // console.log({ fullstore });

  const operatorId = fullstore[0].operatorId;

  // console.log({ operatorId });

  // console.log({ fullstore });
  const [name, setName] = useState(user?.displayName);
  const [email, setEmail] = useState(user?.username);
  const [message, setMessage] = useState("");
  const [mobile, setMobile] = useState(user?.phone);
  const [confirmPass, setConfirmPass] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [selectedNailServices, setSelectedNailServices] = useState([]);
  const [selectedBeautyServices, setSelectedBeautyServices] = useState([]);
  const [selectedNailId, setSelectedNailId] = useState([]);
  const [selectedBeautyId, setSelectedBeautyId] = useState([]);

  // get all data from backend ---------------
  const [nails, setNails] = useState([]);
  const [beauty, setBeauty] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [staffs, setStaffs] = useState([]);

  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedProfessionalId, setSelectedProfessionalId] = useState("any");
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [totalTimeNail, setTotalTimeNail] = useState();
  const [totalTimeBeauty, setTotalTimeBeauty] = useState();

  //processing bar
  const [isUploading, setIsUploading] = useState(false);

  // console.log({ selectedProfessionalId });

  const getBeautyData = async () => {
    try {
      const { response, err } = await sericesApi.getallBeauty({ operatorId });

      if (response && response.data) {
        setBeauty(response.data.beautyservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getNailData = async () => {
    try {
      const { response, err } = await sericesApi.getallNail({ operatorId });

      if (response && response.data) {
        setNails(response.data.nailservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getAllStaff = async () => {
    try {
      const { response, err } = await staffApi.getAllStaffInfo(operatorId);

      if (response && response.data) {
        setStaffs(response.data.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getBeautyData(), getNailData(), getAllStaff()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  //-----------------------------------------
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    const resultError = validateForm({
      name,
      email,
      mobile,
    });

    if (resultError !== null) {
      setError(resultError);
      toast.error(resultError);
      return;
    }

    const formData = {
      operator: operatorId,
      user: user._id,
      selectedNailServices,
      selectedBeautyServices,
      selectedProfessionalId,
      selectedDateTime,
      totalTimeNail,
      totalTimeBeauty,
      name,
      email,
      message,
      mobile,
    };
    setIsProcessing(true);

    console.log({ formData });

    try {
      const { response, err } = await bookingApi.createBooking(formData);

      if (err) {
        throw new Error(err.message || "Create a new staff failed");
      }

      if (response) {
        setIsProcessing(false);
        toast.success(
          "🎉 Appointment booked! 📩 Confirmation email on the way."
        );
        setTimeout(() => {
          navigate("/dashboard");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      setIsProcessing(false); // ✅ Always stop loading
    }
  };

  const handleMultiSelectChange = (e, setter) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    setter(selectedOptions);
  };

  const formData = [
    {
      label: "Nail Service (*)",
      value: selectedNailServices,
      onChange: (e) => handleMultiSelectChange(e, setSelectedNailServices),
      type: "nailservice",
      options: itemNail.map((item) => item.title),
    },

    {
      label: "Beauty Service (*)",
      value: selectedBeautyServices,
      onChange: (e) => handleMultiSelectChange(e, setSelectedBeautyServices),
      type: "beautyservice",
      options: itemBeauty.map((item) => item.title), // Extracting titles for selection
    },
    {
      label: "Select Staffs",
      name: "user_message",
      value: message,
      onChange: (e) => handleMultiSelectChange(e, setSelectedProfessionalId),
      type: "textarea",
    },
    {
      label: "Summary Your Booking",
      name: "summary",
      value: null, // no input field needed for summary
      onChange: (e) => handleMultiSelectChange(e, setSelectedDateTime),
      type: "summary",
    },
    {
      label: "Name (*)",
      value: name,
      onChange: (e) => setName(e.target.value),
      type: "text",
    },
    {
      label: "Email (*)",
      value: email,
      onChange: (e) => setEmail(e.target.value),
      type: "email",
    },
    // {
    //   label: "Mobile (*)",
    //   value: mobile,
    //   onChange: (e) => setMobile(e.target.value),
    //   type: "mobile",
    // },
    {
      label: "Message (*)",
      value: message,
      onChange: (e) => setMessage(e.target.value),
      type: "message",
    },
  ];

  // step setup
  const [currentStep, setCurrentStep] = useState(0);

  const stepGroups = [
    formData.slice(0, 2), // Nail + Beauty
    formData.slice(2, 3), // Staff textarea
    [{ type: "date" }], // Manual slot step
    formData.slice(4), // Name, Email, Mobile
    formData.slice(3, 4), // Summary
  ];

  const isLastStep = currentStep === stepGroups.length - 1;
  const isFirstStep = currentStep === 0;

  const index = currentStep + 1;

  const isStepValid = () => {
    switch (currentStep) {
      case 0:
        return (
          selectedNailServices.length > 0 || selectedBeautyServices.length > 0
        );

      case 1:
        return (
          selectedProfessionalId &&
          typeof selectedProfessionalId === "object" &&
          selectedProfessionalId._id
        );
      case 2:
        return selectedDateTime;

      case 3:
        return (
          //remove checking mobile " "  or "number "
          name.trim() !== "" && email.trim() !== ""
          // && mobile.trim() !== ""

          // &&
          // /^\+?\d{8,15}$/.test(mobile) // allows optional + and 8–15 digits
        );

      case 4:
        return true;

      default:
        return false;
    }
  };

  const getStepError = () => {
    if (currentStep === 3) {
      if (name.trim() === "") return "Name is required";
      if (email.trim() === "") return "Email is required";

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.toLowerCase())) {
        return "Email address is invalid";
      }

      // if (mobile.trim() === "") return "Mobile is required";

      return null;
    }
    return null;
  };

  const stepError = getStepError();
  const isValid = !stepError;

  const handleNext = async () => {
    // if (!isStepValid()) {
    //   toast.error("Please complete this step to continue.");
    //   return;
    // }

    {
      !isValid && currentStep === 3 && (
        <p className="text-sm text-red-500 mt-1">{stepError}</p>
      );
    }
    if (!isLastStep) {
      setIsProcessing(true);
      await new Promise((res) => setTimeout(res, 2000)); // 1-second delay
      setCurrentStep(currentStep + 1);
      setIsProcessing(false);
    }
  };

  const handleBack = () => {
    if (!isFirstStep) {
      setCurrentStep(currentStep - 1);
    }
  };

  const [isTimeLoading, setIsTimeLoading] = useState(false); // Add this at the top

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>Booking | {store.title}</title>
        <meta name="description" content={store.town} />
        <meta property="og:title" content={store.title} />
        <meta property="og:description" content={store.email} />
        <meta property="og:image" content={store.img} />
      </Helmet>

      <FormSection>
        <Container>
          <FormRow small>
            <FormColumn small>
              <p style={{ textTransform: "uppercase" }}>
                Stay in touch with us
              </p>
              <FormTitle textAlign="start" fontSize="36px" mb="5px">
                {" "}
                Booking Now
              </FormTitle>
              <div
                style={{ border: "0.5px solid #fed693", maxWidth: "100px" }}
              ></div>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormWrapper className="space-y-12 p-4 border border-border rounded-xl min-h-[50vh]">
              <div className="border-b border-border">
                <span className="text-4xl font-semibold">{index}</span>{" "}
                <span className="text-lg text-text">/ 5</span>
              </div>
              <div className="my-5">
                <motion.div
                  key={currentStep}
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -50 }}
                  transition={{ duration: 0.3 }}
                >
                  {stepGroups[currentStep].map((el, index) => (
                    <FormInputRow key={index}>
                      {el.type === "textarea" ? (
                        <>
                          <SelectProfessional
                            label={el.label}
                            staffs={staffs}
                            selectedId={selectedProfessionalId}
                            selectedNailservices={selectedNailId}
                            selectedBeautyservices={selectedBeautyId}
                            // onChange={setSelectedProfessionalId}
                            onChange={(staff) => {
                              setSelectedProfessionalId(staff);
                              setTimeout(() => {
                                setCurrentStep(2); // Automatically go to TimeSelector step
                              }, 300); // Small delay for modal closing animation
                            }}
                          />
                        </>
                      ) : el.type === "nailservice" ? (
                        <>
                          <MultiSelectModal
                            name={el.name}
                            label={el.label}
                            totalTime={totalTimeNail}
                            setTotalTime={setTotalTimeNail}
                            options={nails}
                            selectedId={selectedNailId}
                            setSelectedId={setSelectedNailId}
                            selectedValues={selectedNailServices}
                            setSelectedValues={setSelectedNailServices}
                          />
                        </>
                      ) : el.type === "beautyservice" ? (
                        <>
                          <MultiSelectModal
                            name={el.name}
                            label={el.label}
                            totalTime={totalTimeBeauty}
                            setTotalTime={setTotalTimeBeauty}
                            options={beauty}
                            selectedId={selectedBeautyId}
                            setSelectedId={setSelectedBeautyId}
                            selectedValues={selectedBeautyServices}
                            setSelectedValues={setSelectedBeautyServices}
                          />
                        </>
                      ) : el.type === "date" ? (
                        <>
                          <TimeSlotSelector
                            selectedDateTime={selectedDateTime}
                            // setSelectedDateTime={setSelectedDateTime}
                            setSelectedDateTime={(val) => {
                              setSelectedDateTime(val);
                              // setIsTimeLoading(true); // Show loading

                              // setTimeout(() => {
                              //   setIsTimeLoading(false); // Hide loading
                              //   setCurrentStep(3); // Move to next step
                              // }, 2000); // 2s delay (adjust if needed)
                            }}
                            staffs={staffs}
                            selectedProfessionalId={selectedProfessionalId}
                          />
                          {isTimeLoading && (
                            <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-[9999]">
                              <ProcessingBar />
                            </div>
                          )}
                        </>
                      ) : el.type === "summary" ? (
                        <SummaryCard
                          name={name}
                          email={email}
                          mobile={mobile}
                          selectedNailServices={selectedNailServices}
                          selectedBeautyServices={selectedBeautyServices}
                          selectedProfessionalId={selectedProfessionalId}
                          staffs={staffs}
                          selectedDateTime={selectedDateTime}
                          message={message}
                          store={fullstore}
                        />
                      ) : (
                        <FormInput
                          id={el.id}
                          name={el.name}
                          type={el.type}
                          value={el.value}
                          onChange={el.onChange}
                          placeholder={`Please write your ${el.label.toLowerCase()}`}
                        />
                      )}
                    </FormInputRow>
                  ))}
                </motion.div>
              </div>
              {!isStepValid() && (
                <p className="text-sm text-red-500 mt-1">
                  Please complete this step to continue.
                </p>
              )}
              {!isValid && currentStep === 3 && (
                <p className="text-sm text-yellowlight mt-1">{stepError}</p>
              )}
              <div className="flex justify-end space-x-6">
                {!isFirstStep && (
                  <Button
                    onClick={handleBack}
                    type="button"
                    className="h-10 w-40 font-medium border border-yellowlight text-text bg-hidden border-neutral-200 text-neutral-700 dark:bg-neutral-900 dark:text-neutral-300 dark:border-neutral-700 hover:bg-yellowdark dark:hover:bg-neutral-800"
                  >
                    Go back
                  </Button>
                )}

                {!isLastStep ? (
                  <Button
                    onClick={handleNext}
                    type="button"
                    disabled={!isStepValid()}
                    className={`relative h-10 w-40 t font-medium ${
                      isStepValid()
                        ? "bg-yellowlight text-yellowdark hover:bg-yellowdark hover:text-yellowlight border border-yellowlight"
                        : "bg-gray-800 text-gray-600 cursor-not-allowed border border-border"
                    }`}
                  >
                    {isProcessing ? (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <ProcessingBar />
                      </div>
                    ) : (
                      "Continue"
                    )}{" "}
                  </Button>
                ) : (
                  <Button
                    type="button"
                    onClick={() => {
                      if (!user) {
                        dispatch(setAuthModalOpen(true));
                      } else {
                        handleSubmit();
                      }
                    }}
                    disabled={isProcessing} // Optional: prevent double submit
                    className={`relative h-10 w-40 font-medium ${
                      isProcessing
                        ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                        : "bg-yellowlight text-yellowdark hover:bg-yellowdark hover:text-text"
                    }`}
                  >
                    {isProcessing ? (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <ProcessingBar />
                      </div>
                    ) : user ? (
                      "Booking"
                    ) : (
                      "Log in"
                    )}
                  </Button>
                )}
              </div>
            </FormWrapper>
            <FormColumn>
              <AvatarSection>
                <div>
                  <Avatar
                    imgStart={true} // Set to false to align the image to the right
                    imgSrc={store.img}
                    altText="Avatar"
                  />
                </div>
                <AvatarText>
                  <FormTitle
                    textAlign="start"
                    fontSize="20px"
                    co="#fff"
                    fontweight="300"
                    mb="0.5rem"
                  >
                    {store.town}
                  </FormTitle>
                  <FormTitle textAlign="start" fontSize="24px">
                    {store.title}
                  </FormTitle>
                  <FormSubTitle textAlign="start" fontSize="1.2rem">
                    💈 {store.links[0]},&nbsp;{store.links[1]}
                  </FormSubTitle>
                  <FormSubTitle textAlign="start" fontSize="1.2rem">
                    📱 {store.tel_no}
                  </FormSubTitle>
                  <FormSubTitle textAlign="start" fontSize="1.2rem">
                    📩 {store.email}
                  </FormSubTitle>
                </AvatarText>
              </AvatarSection>
              <TextWrapper
                weight="300"
                size="1rem"
                mb="1rem"
                mt="1rem"
                color="#fed693"
                style={{ textAlign: "start", fontStyle: "italic" }}
              >
                Please field the below form and submit (*)
              </TextWrapper>
            </FormColumn>
          </FormRow>
        </Container>
      </FormSection>
    </>
  );
};

export default FormBooking;
